export default {
  props: {
    tagName: {
      type: String,
      required: false,
      default: 'div'
    }
  }
};
